import { SvgIcon } from '@/features/form';
import { makeClassName } from '@/utils';

export default function Icon({ icon, alt = 'icon' }) {
	return (
		<SvgIcon
			className={makeClassName('chat-icon')}
			icon={icon}
			alt={alt}
		/>
	);
}
